import { useSelector } from 'react-redux'
import { Card, CardBody, CardHeader } from 'reactstrap'
import moment from 'moment'
import { useEffect, useState } from 'react'
import AxiosInstance from 'utils/AxiosInstance'
import { getSkills } from 'store/Recruitment/actions'
import { fetchAllStores } from 'store/Stores/actions'
import { useDispatch } from 'react-redux'

import './style.css'

const returnJobType = (jobType) => {
  switch (jobType) {
    case 'fullTime':
      return 'Full Time'
    case 'partTime':
      return 'Part Time'
    default:
      return ''
  }
}

function Details() {
  const dispatch = useDispatch()
  const { jobProps } = useSelector((store) => store.recruitment)
  const { allStores } = useSelector((store) => store.stores)

  const title = jobProps?.find((el) => el?.name === 'title')
  const positions = jobProps?.find((el) => el?.name === 'positions')
  const salary_from = jobProps?.find((el) => el?.name === 'salary_from')
  const start_date = jobProps?.find((el) => el?.name === 'start_date')
  const end_date = jobProps?.find((el) => el?.name === 'end_date')
  const address = jobProps?.find((el) => el?.name === 'address')
  const status = jobProps?.find((el) => el?.name === 'status')
  const location = jobProps?.find((el) => el?.name === 'location')
  const salary_to = jobProps?.find((el) => el?.name === 'salary_to')
  const job_type = jobProps?.find((el) => el?.name === 'job_type')
  const recruitment_type = jobProps?.find(
    (el) => el?.name === 'recruitment_type'
  )
  const category_id = jobProps?.find((el) => el?.name === 'category_id')
  const branch = jobProps?.find((el) => el?.name === 'branch')
  const skills = jobProps?.find((el) => el?.name === 'skills')

  const [category, setCategory] = useState('')
  const [store, setStore] = useState('')

  useEffect(() => {
    AxiosInstance.get(`/recruitment/setup/job_categories`).then((data) => {
      setCategory(data?.find((el) => el.id === category_id?.value))
    })
  }, [category_id])

  useEffect(() => {
    dispatch(fetchAllStores())
  }, [dispatch])

  useEffect(() => {
    setStore(allStores?.find((store) => store.id === branch?.value))
  }, [allStores, branch?.value])

  return (
    <div
      className='category-job-details-container d-flex align-items-start justify-content-between'
      style={{ gap: '2rem' }}
    >
      <Card className='details-card w-50'>
        <CardHeader className='title'>Job Details</CardHeader>
        <CardBody className='d-flex justify-content-between'>
          <div className='w-50'>
            <Field label='Job title' value={title?.value} />
            <Field label='Positions' value={positions?.value} />
            <Field label='Salary From' value={salary_from?.value} />
            <Field
              label='Start Date'
              value={moment(start_date?.value).format('DD-MM-YYYY')}
            />
            <Field label='Address' value={address?.value} />
          </div>
          <div className='w-50'>
            <Field label='Status' value={status?.value} />
            <Field label='Location' value={location?.value} />
            <Field label='Salary To' value={salary_to?.value} />
            <Field
              label='End Date'
              value={moment(end_date?.value).format('DD-MM-YYYY')}
            />
          </div>
        </CardBody>
      </Card>
      <Card className='details-card w-50'>
        <CardHeader className='title'>Category Details</CardHeader>
        <CardBody className='d-flex justify-content-between'>
          <div className='w-50'>
            <Field label='Job Type' value={returnJobType(job_type?.value)} />
            <Field label='Recruitment Type' value={recruitment_type?.value} />
            <Field label='Job Link' value={'-'} />
            <div className='d-flex align-items-center'>
              <p className='mr-3' style={{ color: 'black', fontWeight: '500' }}>
                Skills:{' '}
              </p>
              {skills?.value?.map((skill) => (
                <SkillLabel key={skill?.name} skill={skill?.name} />
              ))}
            </div>
          </div>
          <div className='w-50'>
            <Field label='Job Category' value={category?.value} />
            <Field label='Branch' value={store?.name} />
          </div>
        </CardBody>
      </Card>
    </div>
  )
}

function Field({ label, value }) {
  return (
    <>
      <p className='my-1'>
        <span style={{ color: 'black', fontWeight: '500' }}>{label}:</span>{' '}
        {value}
      </p>
    </>
  )
}

export function SkillLabel({ skill, background = null }) {
  return (
    <div className='d-flex align-items-center h-100 mr-2'>
      <span
        className={`badge px-3 py-2 ${
          background ? background : 'bg-info'
        } text-white`}
      >
        {skill}
      </span>
    </div>
  )
}

export default Details
